import { render } from "./HowItWorks.vue?vue&type=template&id=dbf7f58e"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"
script.render = render

export default script